import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useModal } from "@/modals"
import { Button } from "@/ui/Button"
import { Modal } from "@/ui/Modal"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./MatchSettingsModal.module.scss"

const modalType = "matchSettings"

export const MatchSettingsModal: FC = () => {
  const { t } = useTranslation()
  const { modal, openModal } = useModal(modalType)

  const handleSettings = () => {
    openModal("settings", {
      onBack: () => {
        openModal(modalType)
      }
    })

    modal.close()
  }

  const handleSurrender = () => {
    openModal("matchSurrender", {
      onBack: () => {
        openModal(modalType)
      }
    })

    modal.close()
  }

  const handleClose = () => {
    modal.close()
  }

  return (
    <Modal.Center
      type={modalType}
      className={clsx(styles.MatchSettingsModal)}
      body={{ className: styles.MatchSettingsModal_body }}
    >
      <Modal.StoneFlexContainer
        className={styles.MatchSettingsModal_container}
        content={{ className: styles.MatchSettingsModal_content }}
        outside={
          <>
            <div className={clsx(styles.MatchSettingsModal_footerButtons)}>
              <Button
                className={clsx(styles.MatchSettingsModal_footerButtons_item)}
                styles="green"
                onClick={handleClose}
              >
                {t("button.close")}
              </Button>
            </div>
          </>
        }
      >
        <OutlinedText className={clsx(styles.MatchSettingsModal_title)}>
          {t("gameMenu")}
        </OutlinedText>
        <div className={clsx(styles.MatchSettingsModal_buttons)}>
          <Button
            className={clsx(styles.MatchSettingsModal_buttons_item)}
            styles="red"
            onClick={handleSurrender}
          >
            {t("surrender.title")}
          </Button>
          <Button
            className={clsx(styles.MatchSettingsModal_buttons_item)}
            onClick={handleSettings}
          >
            {t("options")}
          </Button>
          {/* <SkinSwitcher className={clsx(styles.SettingsModal_skinSwitcher)} /> */}
        </div>
      </Modal.StoneFlexContainer>
    </Modal.Center>
  )
}
